// Mirrors the backend `UnlockToken.decodeEmail`: the token is self-describing as
// `<base64url(emailLower)>.<randomBase64url>`, so the email can be recovered from the
// token alone (no separate email field on the client).
export function decodeUnlockTokenEmail(token: string): string | null {
    const separatorIndex = token.indexOf('.');
    if (separatorIndex <= 0) {
        return null;
    }

    try {
        const encodedEmail = token.slice(0, separatorIndex);
        // Node emits base64url without '=' padding; atob needs the padding restored or it
        // throws on inputs whose length isn't a multiple of 4.
        const base64 = encodedEmail.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
        const bytes = Uint8Array.from(atob(padded), (char) => char.charCodeAt(0));
        const email = new TextDecoder().decode(bytes);
        return email.length > 0 ? email.toLowerCase() : null;
    } catch {
        return null;
    }
}
